import { render, staticRenderFns } from "./isolatedExplanation.vue?vue&type=template&id=4ab7ae9f"
import script from "./isolatedExplanation.vue?vue&type=script&lang=js"
export * from "./isolatedExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports